import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="w-full bg-black py-12 px-4" data-id="element-63">
      <div className="max-w-2xl mx-auto text-center" data-id="element-64">
        <h2 className="text-lg sm:text-xl font-bold text-white mb-1" data-id="element-65">
          El próximo domingo podés seguir buscando en YouTube.
        </h2>
        <p className="text-[#00C853] text-xl sm:text-2xl font-black mb-6" data-id="element-66">
          O tener todo resuelto desde hoy.
        </p>

        <div className="mb-6" data-id="element-67">
          <CountdownTimer size="sm" blinking={true} data-id="element-68" />
        </div>

        {/* 2 mini pricing cards */}
        <div className="grid grid-cols-2 gap-3 mb-6" data-id="element-69">
          <div className="bg-[#0a0a0a] border border-[#00C853]/30 rounded-xl p-4 text-center flex flex-col" data-id="element-70">
            <h3 className="text-white font-black text-xs sm:text-sm mb-0.5" data-id="element-71">
              MEGAPACK
            </h3>
            <p className="text-gray-500 text-[9px] sm:text-[10px] mb-2" data-id="element-72">
              6 Tomos + 6 Bonos
            </p>
            <div className="mt-auto" data-id="element-73">
              <span className="text-gray-500 line-through text-[10px]" data-id="element-74">
                $51.000
              </span>
              <p className="text-[#00C853] text-lg sm:text-xl font-black mb-2" data-id="element-75">
                $19.990
              </p>
              <a href="https://www.profepack.com/cart/48174772420864:1" className="btn-green-pulse block bg-[#00C853] text-black font-black py-2.5 rounded-lg hover:bg-[#00E676] transition-colors text-[10px] sm:text-xs" data-id="element-76">
                → QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          <div className="bg-[#000d08] border-2 border-[#00C853] rounded-xl p-4 text-center shadow-[0_0_15px_rgba(0,200,83,0.12)] flex flex-col" data-id="element-77">
            <h3 className="text-[#00C853] font-black text-xs sm:text-sm mb-0.5" data-id="element-78">
              MEGAPACK + DT ⭐
            </h3>
            <p className="text-gray-500 text-[9px] sm:text-[10px] mb-2" data-id="element-79">
              Todo + Manual del DT
            </p>
            <div className="mt-auto" data-id="element-80">
              <span className="text-gray-500 line-through text-[10px]" data-id="element-81">
                $69.000
              </span>
              <p className="text-[#00C853] text-xl sm:text-2xl font-black mb-2" data-id="element-82">
                $27.990
              </p>
              <a href="https://www.profepack.com/cart/48174806237440:1" className="btn-green-pulse block bg-[#00C853] text-black font-black py-2.5 rounded-lg hover:bg-[#00E676] transition-colors text-[10px] sm:text-xs" data-id="element-83">
                → QUIERO EL COMBO ELITE
              </a>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-center gap-3 text-[10px] sm:text-xs text-gray-500" data-id="element-84">
          <span data-id="element-85">🔒 Pago seguro</span>
          <span data-id="element-86">⚡ Acceso inmediato</span>
          <span data-id="element-87">🛡️ Garantía 7 días</span>
        </div>
      </div>
    </section>;
}